import { render } from "./FornitureContrattualizzate.vue?vue&type=template&id=9ae06bc2&scoped=true"
import script from "./FornitureContrattualizzate.vue?vue&type=script&lang=js"
export * from "./FornitureContrattualizzate.vue?vue&type=script&lang=js"

import "./FornitureContrattualizzate.vue?vue&type=style&index=0&id=9ae06bc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae06bc2"]])

export default __exports__